'use client';

import { createContext } from 'react';

import type { UserType } from '~/shared/types/user-type';

export type RootContextType = {
  user: UserType | null;
  lng: string;
};

export const RootContext = createContext({} as RootContextType);
